
interface CookieOptions {
  expires?: number;
  path?: string;
  domain?: string;
  maxAge?: number;
  secure?: boolean;
}

export function setCookie(name: string, value: any, options: CookieOptions = {
  domain: window.location.hostname,
  path: '/'
}): void {
  let optionsString = '';

  if (options.expires) {
    const date = new Date();
    date.setTime(date.getTime() + (options.expires * 1000));
    optionsString += 'expires=' + date.toUTCString() + ';';
  }

  if (options.maxAge) {
    optionsString += 'max-age=' + options.maxAge + ';';
  }

  if (options.path) {
    optionsString += 'path=' + options.path + ';';
  }

  if (options.domain) {
    optionsString += 'domain=' + options.domain + ';';
  }

  if (options.secure) {
    optionsString += 'secure;';
  }

  document.cookie = name + '=' + JSON.stringify(value) + ';' + optionsString;
}

export function getCookie(name: string): any {
  const found = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
  const value = found ? found.pop() : '';

  try {
    return JSON.parse(value);
  } catch (e) {
    return value;
  }
}

export function removeCookie(name: string): void {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT';
}
